// extracted by mini-css-extract-plugin
module.exports = {"log_table_pager_container":"LogTablePager_log_table_pager_container__aLmLV","active":"LogTablePager_active__1Urhc"};